var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cardTest" }, [
    _c("div", { staticClass: "bookCard" }, [
      _c("div", { staticClass: "bookImg" }, [
        _c("img", {
          attrs: {
            src: _vm.i.matchContentVoList.filter(function (item) {
              return item.name == "封面"
            })[0]
              ? _vm.i.matchContentVoList.filter(function (item) {
                  return item.name == "封面"
                })[0].value
              : "",
            alt: "暂无图片",
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bookDesc" }, [
        _c("div", { staticClass: "bookDescTitle" }, [
          _vm._v(_vm._s(_vm.i.bookName)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bookEditor" }, [
          _c("i", { staticClass: "el-icon-user" }),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "作者：" +
                _vm._s(
                  _vm.i.matchContentVoList.filter(function (item) {
                    return item.name == "作者"
                  })[0]
                    ? _vm.i.matchContentVoList.filter(function (item) {
                        return item.name == "作者"
                      })[0].value
                    : ""
                )
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bookPubTime" }, [
          _c("i", { staticClass: "el-icon-date" }),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "出版时间：" +
                _vm._s(
                  _vm.i.matchContentVoList.filter(function (item) {
                    return item.name == "出版时间"
                  })[0]
                    ? _vm.i.matchContentVoList.filter(function (item) {
                        return item.name == "出版时间"
                      })[0].value
                    : ""
                )
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bookNumber" }, [
          _c("i", { staticClass: "el-icon-document" }),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "教材编号(ISBN)：" +
                _vm._s(
                  _vm.i.matchContentVoList.filter(function (item) {
                    return item.name == "教材编号（ISBN）"
                  })[0]
                    ? _vm.i.matchContentVoList.filter(function (item) {
                        return item.name == "教材编号（ISBN）"
                      })[0].value
                    : ""
                )
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bookDescTitle" }, [_vm._v("图书简介：")]),
        _vm._v(" "),
        _c("div", { staticClass: "bookTxt" }, [
          _vm._v(
            "\n          " +
              _vm._s(
                _vm.i.matchContentVoList.filter(function (item) {
                  return item.name == "图书简介"
                })[0]
                  ? _vm.i.matchContentVoList.filter(function (item) {
                      return item.name == "图书简介"
                    })[0].value
                  : ""
              ) +
              "\n        "
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }